module.exports = __webpack_public_path__ + "static/img/15.fd0e99f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/events/15.png
// module id = +Q64
// module chunks = 1